import { type SubscriptionDTO } from "@shared/types/common";

/** How long after its expiration date a self-hosted subscription keeps Authenticated Release. */
const AUTHENTICATED_RELEASE_GRACE_PERIOD_MS = 14 * 24 * 60 * 60 * 1000;

export function useAuthenticatedRelease() {
  /**
   * Mirrors isWithinGracePeriod in myjfrog-api-proxy, which refuses to mint on the same rule.
   *
   * expirationDate is epoch milliseconds. Store always sets it for the self-hosted subscriptions it
   * lists (2200-01-01 when there is no end date), so one without a usable date is bad data and is
   * hidden, like an expired one.
   */
  const isWithinGracePeriod = (subscription: SubscriptionDTO): boolean => {
    const expirationDate = Number(subscription.expirationDate);

    return (
      Number.isFinite(expirationDate) &&
      Date.now() <= expirationDate + AUTHENTICATED_RELEASE_GRACE_PERIOD_MS
    );
  };

  return { isWithinGracePeriod };
}
